var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app" },
    [
      _vm.$auth.ready()
        ? _c(
            "transition",
            { attrs: { name: "fade", mode: "out-in" } },
            [_c("router-view", { key: _vm.$route.fullPath })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$auth.ready()
        ? _c("div", { staticClass: "loading-screen" }, [_vm._m(0)])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading-text" }, [
      _c("p", [_vm._v("Loading ...")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }